export function Brand({ inverse = false, compact = false }: { inverse?: boolean; compact?: boolean }) {
  return (
    <span className={`brand${inverse ? ' brand-inverse' : ''}${compact ? ' brand-compact' : ''}`}>
      <img
        className="brand-product-logo"
        src={compact
          ? '/talos-mark.svg'
          : inverse ? '/talos-logo-white.svg' : '/talos-logo.svg'}
        alt="Talos"
      />
    </span>
  );
}
